/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from "@angular/common";
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
} from "@angular/core";
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
  withNoXsrfProtection,
  withXsrfConfiguration,
} from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CoreModule } from "./@core/core.module";
import { ThemeModule } from "./@theme/theme.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from "@nebular/theme";

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { SduiModule, UIActionHandlersService } from '@edm-sdui/sdui';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { LoginService } from './@core/data/login.service';
import { SduiNavigationService } from './@core/data/navigation.service';
import { DeviceRegistryService } from './@core/data/device-registry.service';
import { FirebaseHelper } from "./@core/services/firebase.helper";

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    ThemeModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    CoreModule.forRoot(),
    NgbModule,
    NgxExtendedPdfViewerModule,
    SduiModule.forRoot({
      baseUrl: environment.urlbase,
    }),
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: "/" },
    provideHttpClient(withInterceptorsFromDi(), withNoXsrfProtection()),
    provideLottieOptions({
      player: () => player,
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: (
        deviceRegistryService: DeviceRegistryService,
        uiHandlers: UIActionHandlersService,
        sduiNavService: SduiNavigationService
      ) => {
        return () => {
          uiHandlers.registerInternalNavigation((url: string) => {
            const handled = sduiNavService.navigateBySduiUrl(url);
            if (!handled) {
              console.warn('[SDUI] URL não tratada:', url);
            }
          });
          return deviceRegistryService.bootstrap();
        };
      },
      deps: [DeviceRegistryService, UIActionHandlersService, SduiNavigationService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (firebaseHelper: FirebaseHelper) => () => {},
      deps: [FirebaseHelper],
      multi: true,
    },
  ]
})
export class AppModule {}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
